import { render, staticRenderFns } from "./userRecycleList.vue?vue&type=template&id=72b64b26&scoped=true&"
import script from "./userRecycleList.vue?vue&type=script&lang=js&"
export * from "./userRecycleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b64b26",
  null
  
)

export default component.exports